export const loadState = { done: false };

export const heroDelay = (d) => (loadState.done ? Math.max(0.1, d - 1.7) : d);
